import { EVENTBRITE_CATEGORY, EVENTBRITE_SUB_CATEGORY } from './constants';

export function isCategory(target: string) {
    return target.startsWith(EVENTBRITE_CATEGORY);
}

export function isSubCategory(target: string) {
    return target.startsWith(EVENTBRITE_SUB_CATEGORY);
}

export const getParentCategoryFromSubCategory = (
    subcategory: string,
): string => {
    const subcategoryId = subcategory.split('/')[1];
    const shouldGrabOneDigit = subcategoryId.length === 4;
    const categoryId = shouldGrabOneDigit
        ? `10${subcategoryId.slice(0, 1)}`
        : `1${subcategoryId.slice(0, 2)}`;

    const categoryKey = `${EVENTBRITE_CATEGORY}/${categoryId}`;
    return categoryKey;
};
